export class CreditsNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalCredits",
            "baseName": "totalCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "remainingCredits",
            "baseName": "remainingCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "usedCredits",
            "baseName": "usedCredits",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "usagePercentage",
            "baseName": "usagePercentage",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "thresholdPercentage",
            "baseName": "thresholdPercentage",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "agreementId",
            "baseName": "agreementId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreditsNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
